import React from 'react'

interface Tab {
  key: string
  label: string
}

interface PageHeaderProps {
  title: string
  tabs?: Tab[]
  activeTab?: string
  onTabChange?: (tabKey: string) => void
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, tabs, activeTab, onTabChange }) => {
  return (
    <div>
      <div style={{ marginBottom: 25 }}>
        <span
          className="text-base font-bold"
          style={{
            fontFamily: 'Montserrat, sans-serif',
            color: '#1E1E1E',
            fontSize: 25,
          }}
        >
          {title}
        </span>
      </div>
      {tabs && tabs.length > 0 && (
        <div className="mb-4">
          <div className="flex gap-8 border-b border-gray-200">
            {tabs.map(tab => (
              <button
                key={tab.key}
                type="button"
                className={`pb-2 text-base font-semibold transition-colors duration-200 ${
                  activeTab === tab.key
                    ? 'text-[#1E1E1E] border-b-2 border-[#1E1E1E]'
                    : 'text-gray-500 border-b-2 border-transparent hover:text-[#1E1E1E]'
                }`}
                style={{ fontFamily: 'Montserrat, sans-serif' }}
                onClick={() => onTabChange?.(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

PageHeader.defaultProps = {
  tabs: undefined,
  activeTab: undefined,
  onTabChange: undefined,
}

export { PageHeader }
